window.refreshKlarnaPlacements = function refreshKlarnaPlacements () {
  queueMicrotask(() => {
    if (window.Klarna?.OnsiteMessaging?.refresh) {
      window.Klarna.OnsiteMessaging.refresh()
    } else if (Array.isArray(window.KlarnaOnsiteService)) {
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
    }
  })
}

window.updateProductKlarnaPlacement = function updateProductKlarnaPlacement () {
  const placement = document.getElementById('KlarnaPlacement-product')
  const button = document.querySelector('product-form .product-form__submit')
  if (!placement || !button) return

  const amountEl = [...button.querySelectorAll('[data-klarna-amount]')].find((el) => {
    return window.getComputedStyle(el).display !== 'none'
  })
  const amount = Math.round(Number(amountEl?.getAttribute('data-klarna-amount')))
  if (!amount) return

  if (placement.getAttribute('data-purchase-amount') === String(amount)) return

  placement.setAttribute('data-purchase-amount', String(amount))
  window.refreshKlarnaPlacements()
}

function watchAtcButtonKlarna () {
  const form = document.querySelector('product-form form')
  const button = document.querySelector('product-form .product-form__submit')
  if (!form && !button) return

  const observer = new MutationObserver(() => {
    window.updateProductKlarnaPlacement()
  })

  if (form) {
    observer.observe(form, { attributes: true, attributeFilter: ['data-include-partner-product'] })
  }

  if (button) {
    observer.observe(button, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-klarna-amount'],
    })
  }

  window.updateProductKlarnaPlacement()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchAtcButtonKlarna)
} else {
  watchAtcButtonKlarna()
}

class CartDrawer extends HTMLElement {
  constructor () {
    super()
    this.dialog = this.querySelector('.drawer__inner')
    this.overlay = this.querySelector('#CartDrawer-Overlay')
    this.boundClose = this.close.bind(this)

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.addEventListener('click', (event) => {
      const closeTrigger = event.target.closest('[data-cart-drawer-close]')
      if (!closeTrigger) return
      event.preventDefault()
      this.close()
    })
    if (this.overlay) this.overlay.addEventListener('click', this.boundClose)
    if (this.dialog) {
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault()
        this.close()
      })
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close()
      })
    }
    this.setHeaderCartIconAccessibility()

    window.BAO.eventBus.addEventListener(window.BAO.EVENTS.PUSH_CART.LOG_IN, () => {
      this.close()
    })

    // Update cart if back button clicked
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) this.renderContents()
    })

    if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
      this.renderContents()
    }
  }

  setHeaderCartIconAccessibility () {
    const cartLink = document.querySelector('#cart-icon-bubble')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open (triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote)
    if (this.dialog?.showModal && !this.dialog.open) this.dialog.showModal()
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active')
      window.refreshKlarnaPlacements?.()
    })

    this.addEventListener('transitionend', () => {
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
      if (focusElement && typeof focusElement.focus === 'function') {
        focusElement.focus()
      }
    }, { once: true })

    document.body.classList.add('overflow-hidden')
  }

  close () {
    if (this.dialog?.open) this.dialog.close()
    this.classList.remove('active')
    if (this.activeElement && typeof this.activeElement.focus === 'function') {
      this.activeElement.focus()
    }
    document.body.classList.remove('overflow-hidden')
  }

  setSummaryAccessibility (cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id)
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
    })

    // eslint-disable-next-line no-undef
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  async renderContents (parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty')
    if (parsedState) {
      this.productId = parsedState.id
    }

    if (!parsedState || !parsedState.sections) {
      // eslint-disable-next-line no-undef
      const sections = await fetch(`${routes.cart_url}?sections=${this.getSectionsToRender().map(section => section.id)}`)
      parsedState.sections = await sections.json()
    }

    this.getSectionsToRender().forEach(section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id)
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
    })

    window.refreshKlarnaPlacements?.()

    setTimeout(() => {
      this.overlay = this.querySelector('#CartDrawer-Overlay')
      if (this.overlay) {
        this.overlay.removeEventListener('click', this.boundClose)
        this.overlay.addEventListener('click', this.boundClose)
      }
      this.dialog = this.querySelector('.drawer__inner')
      this.open()
    })
  }

  getSectionInnerHTML (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  getSectionsToRender () {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ]
  }

  getSectionDOM (html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
  }

  setActiveElement (element) {
    this.activeElement = element
  }
}

customElements.define('cart-drawer', CartDrawer)

// eslint-disable-next-line no-undef
class CartDrawerItems extends CartItems {
  getSectionsToRender () {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)
